import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { getTableCells, methodResult, responseType } from '../../../utils/TableCells';
import { actions } from '../../modules/Actions';
import { addRowTotalAndColumnTotal, columnDisps, columnKeys, rowData, TableDataProps } from '../../../utils/NegotiationReducerUtils';
import { getReportTableRowKeys } from '../ReportTableRowReducer';
import _isEqual from 'lodash/isEqual';
import { negotiationResultViewColumns } from '../../../Common';

export const resultInitialState: TableDataProps = {
  // Stateの初期値
  header: columnKeys(negotiationResultViewColumns),
  headerDisp: columnDisps(negotiationResultViewColumns),
  data: rowData(),
};

function makingTableData(dtoToViewTable: methodResult, viewRow: string[]) {
  return {
    header: resultInitialState.header,
    headerDisp: resultInitialState.headerDisp,
    data: addRowTotalAndColumnTotal(dtoToViewTable, viewRow),
  };
}

export const NegotiationResultReducer = reducerWithInitialState(resultInitialState).case(
  actions.updateNegotiation.result,
  (state: TableDataProps, payload: responseType) => {
    const rowKeys = getReportTableRowKeys();
    const viewRowWithoutTotal = rowKeys.slice(1);
    const viewColumnsWithoutTotal = columnKeys(negotiationResultViewColumns).slice(0, -1);
    const tableCells = getTableCells(payload, viewColumnsWithoutTotal, viewRowWithoutTotal);
    const newState = makingTableData(tableCells, viewRowWithoutTotal);

    return _isEqual(state.data, newState.data) ? state : newState;
  }
);
